module.exports = __webpack_public_path__ + "static/img_2112-6a25403b087dd0e1ebe7017b065b01d0.webp";